export const CryptoCurrencies = Object.freeze({
	USDT: "USDT",
	BTC: "BTC",
	USDC: "USDC",
	ETH: "ETH",
	BNB: "BNB",
	TRX: "TRX",
	LTC: "LTC",
	XRP: "XRP",
	DOGE: "DOGE",
});
